import { yupResolver } from "@hookform/resolvers/yup";
import { Autocomplete, Box, FormControl, TextField } from "@mui/material";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { SyncLoader } from "react-spinners";
import { toast, ToastContainer, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as yup from "yup";
import { ThemButton } from "../../components/Login/Login.style";
import useGetAllStudies from "../../hooks/useGetAllStudies";
import useGetFreshVolunteerList from "../../hooks/useGetFreshVolunteerList";
import { handleAddClose } from "../../redux/Reducer/ModalSlice";
import useGetVolunteersByTrialId from "../../hooks/useGetVolunteersByTrialId";

const schema = yup.object().shape({
  study_no: yup.string().required("Study is required"),
  trial_id: yup.string().required("Trial is required"),
  vol_no: yup.string().required("Volunteer is required"),
});

const TrialAdd = ({ trialCode }) => {
  const dispatch = useDispatch();
  const userId = localStorage.getItem("uI");
  const user_id = userId - 786;

  const { refetch } = useGetVolunteersByTrialId(trialCode);

  // inactive volunteer list api call
  const { getFreshVolunteerList, getFreshVolunteerRefetch } =
    useGetFreshVolunteerList();

  // const inactiveVolunteerInfoOptions = getFreshVolunteerList?.map(
  //   (inActiveVolunteer) => ({
  //     label: `${inActiveVolunteer?.full_name} - ${inActiveVolunteer?.vol_id} ${inActiveVolunteer?.vol_last_history?.study_name
  //       ? `- ${inActiveVolunteer?.vol_last_history?.study_name}`
  //       : ""
  //       } ${inActiveVolunteer?.vol_last_history?.complete_date
  //         ? `- ${inActiveVolunteer?.vol_last_history?.complete_date}`
  //         : ""
  //       } ${inActiveVolunteer?.vol_last_history?.outcome_of_trial
  //         ? `- ${inActiveVolunteer?.vol_last_history?.outcome_of_trial}`
  //         : ""
  //       }`,
  //     value: inActiveVolunteer?.vol_no,
  //   })
  // );

  // ==================
  const inactiveVolunteerInfoOptions = getFreshVolunteerList?.map((v) => ({
    value: v?.vol_no,
    name: v?.full_name || "",
    volId: v?.vol_id || "",
    studyName: v?.vol_last_history?.study_name || "",
    completeDate: v?.vol_last_history?.complete_date || "",
    outcome: v?.vol_last_history?.outcome_of_trial || "",
  }));

  // study list
  const [getAllStudiesList] = useGetAllStudies();
  const studiesListOptions = getAllStudiesList?.map((study) => ({
    label: study?.protocol_title,
    value: study?.study_no,
  }));
  // console.log("studies list options", studiesListOptions);

  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = (data, e) => {
    // const dataToSent = {
    //   ...data,
    //   created_by: `${user_id}`,
    //   active_flag: "1",
    // };
    // console.log("add to trial =>>> ", data);
    // console.log("add to trial data to sent =>>> ", dataToSent);
    const formData = new FormData();
    formData.append("vol_no", data.vol_no);
    formData.append("study_no", data.study_no);
    formData.append("trial_id", data.trial_id);
    formData.append("created_by", `${user_id}`);
    formData.append("active_flag", "1");

    // console.log("Trial Mapping Data:", Object.fromEntries(formData));
    setIsLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/api/trial-mapping`, {
      method: "POST",
      body: formData,
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.meta.http_status === 201) {
          toast.success("Volunteer add successfully!.", {
            position: toast.POSITION.TOP_CENTER,
          });

          refetch();
          getFreshVolunteerRefetch();
          reset();
          dispatch(handleAddClose());
        } else if (data.meta.http_status === 404) {
          toast.error("Oops! There was an issue adding volunteer.", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .finally(() => setIsLoading(false));
    dispatch(handleAddClose());
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div style={{ padding: "20px", paddingLeft: "0px" }}>
          {/* study list */}
          <Box p="10px 20px 30px 20px">
            <FormControl style={{ width: "100%" }}>
              <Controller
                name="study_no"
                control={control}
                defaultValue=""
                render={({ field: { onChange, value } }) => (
                  <Autocomplete
                    options={studiesListOptions}
                    getOptionLabel={(option) => {
                      if (typeof option === "string") return option;
                      return option?.label ?? "";
                    }}
                    value={
                      studiesListOptions.find(
                        (option) => option.value === value
                      ) || null
                    }
                    onChange={(_, newValue) => {
                      onChange(newValue ? newValue.value : "");
                    }}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        fullWidth
                        {...params}
                        label="Select Study"
                        variant="standard"
                        error={!!errors.study}
                        helperText={errors.study ? errors.study.message : ""}
                      />
                    )}
                  />
                )}
              />
            </FormControl>
          </Box>

          {/* trial list */}
          <Box p="10px 20px 10px 20px">
            <Controller
              name="trial_id"
              control={control}
              defaultValue={trialCode}
              render={({ field }) => (
                <TextField
                  size="small"
                  fullWidth
                  label="Trial Code*"
                  variant="outlined"
                  disabled
                  InputProps={{ readOnly: true }}
                  {...field}
                />
              )}
            />
          </Box>

          {/* volunteer list */}
          <Box p="5px 20px 10px 20px">
            <FormControl style={{ width: "100%" }}>
              <Controller
                name="vol_no"
                control={control}
                defaultValue=""
                render={({ field: { onChange, value } }) => (
                  <Autocomplete
                    options={inactiveVolunteerInfoOptions}
                    getOptionLabel={(option) => option?.name ?? ""}
                    value={
                      inactiveVolunteerInfoOptions.find(
                        (option) => option.value === value
                      ) || null
                    }
                    onChange={(_, newValue) => {
                      onChange(newValue ? newValue.value : "");
                    }}

                    PaperComponent={({ children }) => (
                      <Box
                        sx={{
                          backgroundColor: "#fff",
                          border: "1px solid rgba(0,0,0,0.12)",
                          borderRadius: "4px",
                          boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                          overflow: "hidden",
                        }}
                      >
                        <Box sx={{ maxHeight: 250, overflowY: "auto" }}>
                          {/* Sticky Header */}
                          <Box
                            sx={{
                              display: "grid",
                              gridTemplateColumns: "2fr 1fr 1fr 1fr 2fr", // Same layout for rows
                              fontWeight: "bold",
                              backgroundColor: "#f5f5f5",
                              borderBottom: "1px solid #ccc",
                              padding: "6px 8px",
                              position: "sticky",
                              top: 0,
                              zIndex: 1,
                              boxSizing: "border-box",
                            }}
                          >
                            <span style={{ textAlign: "center" }}>Name</span>
                            <span style={{ textAlign: "center" }}>ID</span>
                            <span style={{ textAlign: "center" }}>Study</span>
                            <span style={{ textAlign: "center" }}>Date</span>
                            <span style={{ textAlign: "center" }}>Outcome</span>
                          </Box>

                          {/* Data Rows */}
                          {React.Children.map(children, (child) => {
                            if (!React.isValidElement(child)) return child;

                            // Pass grid layout to each option
                            return React.cloneElement(child, {
                              sx: {
                                display: "grid",
                                gridTemplateColumns: "1fr",
                                padding: "6px 8px",
                                // "&:hover": { backgroundColor: "#f0f0f0" },
                                boxSizing: "border-box",
                              },
                            });
                          })}
                        </Box>
                      </Box>
                    )}

                    renderOption={(props, option) => (
                      <div
                        // component="li"
                        {...props}
                        style={{
                          display: "grid",
                          gridTemplateColumns: "2fr 1fr 1fr 1fr 2fr",
                          padding: "6px 8px",
                          borderTop: "1px solid #615f5fff",
                          width: "100%",
                          boxSizing: "border-box",
                          "&:hover": { backgroundColor: "#f0f0f0" },
                        }}
                      >
                        <Box sx={{
                          textAlign: "center",
                        }}> {option.name ? option.name : "---"}</Box>
                        <Box sx={{
                          textAlign: "center",
                        }}>{option.volId ? option.volId : "---"}</Box>
                        <Box sx={{
                          textAlign: "center",
                        }}> {option.studyName ? option.studyName : "---"}</Box>
                        <Box sx={{
                          textAlign: "center",
                        }}>{option.completeDate ? option.completeDate : "---"}</Box>
                        <Box sx={{
                          textAlign: "center",
                        }}> {option.outcome ? option.outcome : "---"}</Box>
                      </div>
                    )}

                    renderInput={(params) => (
                      <TextField
                        size="small"
                        fullWidth
                        {...params}
                        label="Select volunteer"
                        variant="standard"
                        error={!!errors.volunteer}
                        helperText={errors.volunteer ? errors.volunteer.message : ""}
                      />
                    )}
                  />
                )}
              />
            </FormControl>
          </Box>
        </div>

        {/* add button */}
        <Box sx={{ mb: "15px", display: "flex", justifyContent: "center" }}>
          {isLoading ? (
            <ThemButton style={{}} type="submit">
              <SyncLoader color="#FFFFFF" size={8} />
            </ThemButton>
          ) : (
            <ThemButton style={{}} type="submit">
              Add Volunteer
            </ThemButton>
          )}

          <ToastContainer
            autoClose={2000}
            limit={1}
            transition={Zoom}
            toastStyle={{ border: "2px solid crimson" }}
          />
        </Box>
      </form>
    </>
  );
};

export default TrialAdd;
